import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../../components/Seo/seo'
import { useIntl } from 'react-intl'
import Layout from '../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../routes'
import { services } from '../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { FormLoader } from '../../../components/Loader/FormLoader'
import ServicesContent from '../../../components/Dashboard/Subscription/ServicesContent'
import { LanguageConsumer } from '../../../LanguageContext'


const Services = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Sidebar.Links.Services' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={services.image}
           description={intl.formatMessage({ id: 'Sidebar.Links.Services' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true}/>}
            {!!Object.keys(userData).length &&
            <>
              {!!userData.is_admin ?
                <Layout content={<LanguageConsumer>
                  {({ locale }) => (
                    <ServicesContent handleNotificationCall={handleNotificationCall} locale={locale}/>
                  )}
                </LanguageConsumer>}/> :
                (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default Services

